import * as math from 'mathjs'
import funDataJson from '@/assets/fundata.json'
import { getResByDatasetIdApi } from "@/api/dataset/dataset";
import { execMethod } from "@/utils/jsfunction-handler";


export function TYEAR() {  // TYEAR()
  return new Date().getFullYear();
}
export function TMONTH() {  // TMONTH()
  let year = new Date().getFullYear();
  let month = new Date().getMonth() + 1;
  return year + "-" + (month < 10 ? "0" : "") + month;
}
export function TDAY() {  // TDAY()
  let year = new Date().getFullYear();
  let month = new Date().getMonth() + 1;
  let day = new Date().getDate();
  return year + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;
}
export function YEAR(year, num) {   //YEAR(2023,1)   YEAR(2023,-1)
  const date = new Date(year, 0)
  date.setFullYear(date.getFullYear() + num)
  return date.getFullYear()
}
export function YEARMONTH(dateStr, num) { //YEARMONTH(2023-12,1)  YEARMONTH(2023-12,-1)
  const date = new Date(dateStr + "-01");
  date.setMonth(date.getMonth() + num);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  return `${year}-${month}`;
}
export function YEARMONTHDAY(date, num) {  //YEARMONTHDAY(2023-12-01,5)  YEARMONTHDAY(2023-12-01,-1)
  const currentDate = new Date(date);
  const futureDate = new Date(currentDate.setDate(currentDate.getDate() + num));
  const year = futureDate.getFullYear();
  const month = (futureDate.getMonth() + 1).toString().padStart(2, '0');
  const day = futureDate.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}


export function finArrChildrenValue(arr, key, value) {
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i];
    if (item[key] === value) {
      return item;
    }
    if (Array.isArray(item)) {
      const result = findValue(item, key, value);
      if (result) {
        return result;
      }
    }
  }
  return null;
}


export const commonFuntion = {
  SUM(...args) {
    return math.sum(args)
  },
  MAX(...args) {
    return math.max(...args)
  },
  MIN(...args) {
    return math.min(...args)
  },
  MEAN(...args) {
    return math.mean(args)
  },
  RANDOM(max) {
    return Math.floor((math.random() * max) + 1);
  }
}


export class CommonFuncCalculate {
  static commonFuntion = commonFuntion
  static init(value, variables) {
    console.log(funDataJson, 'funDataJson')
    const funs = funDataJson.funData[1].data
    let valuesInString = CommonFuncCalculate.replaceValuesInString(funs, value)
    const addVariablesValue = CommonFuncCalculate.addVariablesValue(valuesInString, variables)
    const result = CommonFuncCalculate.calculateFormula(addVariablesValue, {})
    console.log(result, valuesInString, addVariablesValue, 'qwdijqwdjiqwidwqiqwid');
    return {
      result,
      valuesInString
    }
  }
  static replaceValuesInString(functions, str) {
    let replaceValuesInString = functions.reduce((accumulator, curr) => {
      // 创建一个替换函数，它查找并替换匹配的标题
      accumulator = accumulator.replace(new RegExp(curr.title, 'g'), curr.value);
      // 返回替换后的 accumulator，准备进行下一轮替换
      return accumulator;
    }, str);

    return replaceValuesInString
  }
  static addVariablesValue(value, variables) {
    const variable = CommonFuncCalculate.flattenVariables(variables)
    variable.forEach(item => {
      let regExp = new RegExp(`{${item.field}}`, 'g')
      value = value.replace(regExp, item.value)
    })
    return value
  }
  // 拆解functionVariables变量
  static flattenVariables(arr) {
    let result = [];
    arr.forEach(item => {
      if (!item.children) {
        result.push(item);
      }
      if (item.children && Array.isArray(item.children)) {
        result = result.concat(CommonFuncCalculate.flattenVariables(item.children));
      }
    });
    return result;
  }
  static calculateFormula(formula, variables = {}) {
    try {
      const scope = { ...variables, ...CommonFuncCalculate.commonFuntion }
      let result = math.evaluate(formula, scope)
      return CommonFuncCalculate.truncateToTwoDecimalPlaces(result)
    } catch (error) {
      console.error("Error evaluating formula:", error);
      return 'error'
    }
  }
  static truncateToTwoDecimalPlaces(value) {
    if (typeof value === 'number' && !isNaN(value)) {
      return Number(value.toFixed(2));
    } else {
      throw new Error('The provided argument is not a valid number.');
    }
  }



}

export class DatasetFuncValue {
  static async init(datasetValue, dataset, current) {
    return await getResByDatasetIdApi(dataset.id, 'sql', { id: current.id }).then(res => {
      if (res.code == 200) {
        const result = JSON.parse(res.data.apiRes);
        return result;
      } else {
        console.log('获取数据集失败')
      }
    })
  }
}


//需要判断是否登录或者用户地址
export const LoginArrId = [
  '9e9da190-295e-11ef-b380-57345ca3eb28',
  "09d37950-2791-11ef-b882-315ba0bee70b",
  "8b0abc18-2fb4-11ef-bd62-ef8bbc19e881",
  "8b0bcd88-2fb4-11ef-bd62-ef8bbc19e881",
  "8dd02b70-27a2-11ef-a432-152d672ea11d",
  "30d595d0-27c1-11ef-b4db-279f78acd57a",
  "da1dc450-27c1-11ef-b4db-279f78acd57a",
  "4112ecc0-27c3-11ef-b4db-279f78acd57a"
]



export function getQueryParams() {
  const query = window.location.search.substring(1);
  const params = {};
  query.split('&').forEach(pair => {
    const [key, value] = pair.split('=');
    params[key] = decodeURIComponent(value || '');
  });
  return params;
}